import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AgentPaymentRoutes = defineRoute({
    record: {
        route: {
            path: "/agent-payment",
            component: () => loadView(import("./AgentPaymentTable.vue")),
        },
    },
});
